<template>
  <div>
    <div class="title-div">燃气电子发票详情</div>
    <div class="tip-div">
      <div class="careful-div">
        <div class="img-div">
          <img src="../../../assets/pc/gasInvoice/careful.png">
          注：
        </div>
        <div>
          1、发票类型是增值税普通发票<br/>
          2、发票申请提交之后无法撤回<br/>
          3、如您对发票内容有特殊需求，请与拨打：<span class="phone-span">96777</span>
        </div>
      </div>
    </div>
    <div class="form-div" v-loading="loading">
      <div class="invoice-type-div">发票类型</div>
      <div class="button-div">
        <el-button class="button-style" :class="isCheck == '个人' ? 'check-btn' : 'no-btn'" @click="onBtn('个人')">个人
        </el-button>
        <el-button class="button-style" :class="isCheck == '企业' ? 'check-btn' : 'no-btn'" @click="onBtn('企业')">企业
        </el-button>
      </div>
      <div class="invoice-type-div invoice-detail-div">发票类明细</div>
      <el-form ref="form" :model="form" label-width="80px" label-position="top" :rules="rules">
        <el-form-item label="发票抬头：" prop="invoiceHeader">
          <el-input v-model="form.invoiceHeader" placeholder="请输入"
                    class="invoice-header-input invoice-header" maxlength="100"></el-input>
        </el-form-item>
        <div class="row-div">
          <div class="left-cell">发票内容</div>
          <div class="right-cell">燃气费</div>
        </div>
        <div class="row-div invoice-amount-div">
          <div class="left-cell">发票金额</div>
          <div class="right-cell">{{form.fqMoney}}元</div>
        </div>
        <el-form-item label="联系人邮箱：" prop="contactEmail">
          <el-input v-model="form.contactEmail" placeholder="邮箱用于接收发票链接" class="invoice-header-input"></el-input>
          <div class="img-style">
            <el-popover
              placement="right"
              width="200"
              trigger="click"
              content="请输入您常用的电子邮箱（如QQ邮箱）">
              <img src="../../../assets/pc/gasInvoice/question.png" slot="reference">
            </el-popover>
          </div>
        </el-form-item>
        <el-form-item label="电话：" prop="telephone">
          <el-input v-model="form.telephone" placeholder="请填写联系电话" class="invoice-header-input"
                    maxlength="11"></el-input>
          <div class="img-style">
            <el-popover
              placement="right"
              width="200"
              trigger="click"
              content="请输入11位数字的手机号">
              <img src="../../../assets/pc/gasInvoice/question.png" slot="reference">
            </el-popover>
          </div>
        </el-form-item>
        <div v-if="isCheck == '企业'">
          <el-form-item label="纳税人识别号：" prop="regNum">
            <el-input v-model="form.regNum" placeholder="请填写纳税人识别号" class="invoice-header-input"
                      maxlength="18"></el-input>
            <div class="img-style">
              <el-popover
                placement="right"
                width="200"
                trigger="click"
                content="1~18位数字或字母组合">
                <img src="../../../assets/pc/gasInvoice/question.png" slot="reference">
              </el-popover>
            </div>
          </el-form-item>
        </div>
        <el-form-item label="备注：" v-if="isCheck == '个人'">
          <el-input type="textarea" v-model="form.selfRemarks" placeholder="请填写备注信息"
                    class="invoice-header-input" maxlength="100"></el-input>
          <div class="img-style">
            <el-popover
              placement="right"
              width="200"
              trigger="click"
              content="只允许输入汉字、阿拉伯数字，中文的（逗号，句号，冒号,顿号,分号），英文的（括号，逗号，句号，横杠，加号，分号，冒号）  大小写字母，长度限制为100个字符">
              <img src="../../../assets/pc/gasInvoice/question.png" slot="reference">
            </el-popover>
          </div>
        </el-form-item>
        <el-collapse v-model="activeNames" v-if="isCheck == '企业'" @change="handleChange">
          <el-collapse-item name="1">
            <template slot="title">
              <div class="more-span">更多开票信息</div>
            </template>
            <el-form-item label="开户行名称：">
              <el-input v-model="form.depositBank" placeholder="请填写开户行名称" class="invoice-header-input"
                        maxlength="70"></el-input>
              <div class="img-style">
                <el-popover
                  placement="right"
                  width="200"
                  trigger="click"
                  content="只允许输入汉字、大写字母、英文括号，不能有空格，长度限制为70个字符">
                  <img src="../../../assets/pc/gasInvoice/question.png" slot="reference">
                </el-popover>
              </div>
            </el-form-item>
            <el-form-item label="开户行账号：">
              <el-input v-model="form.accountNumber" placeholder="请填写开户行账号" class="invoice-header-input"
                        maxlength="30"></el-input>
              <div class="img-style">
                <el-popover
                  placement="right"
                  width="200"
                  trigger="click"
                  content="只允许输入阿拉伯数字、英文横杠符号，长度限制为30个字符，不能有空格">
                  <img src="../../../assets/pc/gasInvoice/question.png" slot="reference">
                </el-popover>
              </div>
            </el-form-item>
            <el-form-item label="公司地址：">
              <el-input v-model="form.companyAddress" placeholder="请填写公司地址" class="invoice-header-input"
                        maxlength="70"></el-input>
              <div class="img-style">
                <el-popover
                  placement="right"
                  width="200"
                  trigger="click"
                  content="只允许输入汉字、阿拉伯数字、英文的（括号、横杠、&符号、#符号）、大小写字母，不能有空格，长度限制为70个字符">
                  <img src="../../../assets/pc/gasInvoice/question.png" slot="reference">
                </el-popover>
              </div>
            </el-form-item>
            <el-form-item label="公司联系电话：">
              <el-input v-model="form.companyPhone" placeholder="请填写公司联系电话" class="invoice-header-input"
                        maxlength="18"></el-input>
              <div class="img-style">
                <el-popover
                  placement="right"
                  width="200"
                  trigger="click"
                  content="只允许输入数字、英文的（横杠，加号），长度限制为30个字符">
                  <img src="../../../assets/pc/gasInvoice/question.png" slot="reference">
                </el-popover>
              </div>
            </el-form-item>
            <el-form-item label="备注：">
              <el-input type="textarea" v-model="form.remarks" placeholder="请填写备注信息"
                        class="invoice-header-input" maxlength="100"></el-input>
              <div class="img-style">
                <el-popover
                  placement="right"
                  width="200"
                  trigger="click"
                  content="只允许输入汉字、阿拉伯数字，中文的（逗号，句号，冒号,顿号,分号），英文的（括号，逗号，句号，横杠，加号，分号，冒号）  大小写字母，长度限制为100个字符">
                  <img src="../../../assets/pc/gasInvoice/question.png" slot="reference">
                </el-popover>
              </div>
            </el-form-item>
          </el-collapse-item>
        </el-collapse>
        <el-form-item>
          <el-button type="primary" class="submit-button" @click="onSubmit">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <div class="tip-div-invoice">发票申请提交后无法撤回，请确认您填写的信息无误</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false" class="cancel-button">取 消</el-button>
        <el-button type="primary" @click="onConfirm()" class="confirm-button">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { applyBilling, getData } from '../../../api/bill'

  export default {
    name: 'PCGasInvoiceDetail',
    data () {
      let checkContactEmail = (rule, value, callback) => {
        if (value) {
          let rgx = /^\w[-\w.+]*@([A-Za-z0-9][-\w]+\.)+[A-Za-z]{2,14}$/
          if (!rgx.test(value)) {
            return callback(new Error('请输入合法的邮箱'))
          } else {
            callback()
          }
        }
      }
      let checkTelephone = (rule, value, callback) => {
        if (value) {
          let rgx = /[0-9]{11}/
          if (!rgx.test(value)) {
            return callback(new Error('请输入有效的手机号'))
          } else {
            callback()
          }
        }
      }
      let checkRegNum = (rule, value, callback) => {
        if (value) {
          let rgx = /^[a-zA-Z0-9]{1,18}$/
          if (!rgx.test(value)) {
            return callback(new Error('请填写有效的纳税人识别号'))
          } else {
            callback()
          }
        }
      }
      return {
        form: {
          invoiceHeader: '', // 发票抬头
          contactEmail: '', // 联系人邮箱
          telephone: '', // 电话
          regNum: '', // 纳税人识别号
          depositBank: '', // 开户行名称
          accountNumber: '', // 开户行账号
          companyAddress: '', // 公司地址
          companyPhone: '', // 公司联系电话
          remarks: '', // 备注
          selfRemarks: '', // 个人备注
          fqMoney: 0 // 发票金额
        },
        rules: {
          invoiceHeader: [
            {
              required: true,
              message: '请输入发票抬头',
              trigger: 'blur'
            },
          ],
          contactEmail: [
            {
              required: true,
              message: '请输入联系人邮箱',
              trigger: 'blur'
            }, {
              validator: checkContactEmail,
              trigger: 'blur'
            }
          ],
          telephone: [
            {
              required: true,
              message: '请填写联系电话',
              trigger: 'blur'
            }, {
              validator: checkTelephone,
              trigger: 'blur'
            }
          ],
          regNum: [
            {
              required: true,
              message: '请填写纳税人识别号',
              trigger: 'blur'
            }, {
              validator: checkRegNum,
              trigger: 'blur'
            }
          ]
        },
        activeNames: [], // 展开的折叠面板
        isCheck: '个人', // 发票类型
        centerDialogVisible: false, // 是否显示确认提交对话框
        loading: false, // 是否显示加载提示
        gasAccountInfo: {} // 户号信息
      }
    },
    created () {
      this.gasAccountInfo = this.$route.params.gasAccountInfo
      const selectArr = this.$route.params.arr
      selectArr.forEach(item => {
        this.form.fqMoney = this.form.fqMoney + Number(item.payAmt)
      })
      this.getApi()
    },
    methods: {
      onSubmit () {
        const that = this
        that.$refs['form'].validate((valid) => {
          if (valid) {
            that.centerDialogVisible = true
          } else {
            return false
          }
        })
      },

      // 当前激活面板改变时触发
      handleChange (val) {
        console.log(val)
      },

      // 企业、个人按钮切换
      onBtn (val) {
        if (val === '企业') {
          this.getApi()
        }
        this.isCheck = val
      },

      // 企业类型，查询纳税识别号
      getApi () {
        // 发票开票信息查询
        const pa = {
          'CM-CXFPINFO': {
            input: {
              acctId: this.gasAccountInfo.gasAccount
            }
          }
        }
        getData(JSON.stringify(pa)).then(res => {
          if (res.data && res.data['soapenv:Envelope'] && res.data['soapenv:Envelope']['soapenv:Body'] && res.data['soapenv:Envelope']['soapenv:Body']['CM-CXFPINFO'] && res.data['soapenv:Envelope']['soapenv:Body']['CM-CXFPINFO'].fpInfo) {
            const data = res.data['soapenv:Envelope']['soapenv:Body']['CM-CXFPINFO'].fpInfo
            this.form.regNum = data.TaxRegNum ? data.TaxRegNum : ''
          }
        })
      },

      // 确认提交
      onConfirm () {
        const that = this
        that.centerDialogVisible = false
        that.loading = true
        // 申请开票接口
        const params = {
          uniUserCode: that.gasAccountInfo.gasAccount,
          invType: that.isCheck === '企业' ? 'B' : 'R', // 发票类型
          invTit: that.form.invoiceHeader, // 发票抬头
          invCnt: '燃气费',
          invPri: that.form.fqMoney, // 发票金额
          phoNum: that.form.telephone, // 电话
          emailAdr: that.form.contactEmail, // 邮箱
          uniUserPhoneNum: JSON.parse(window.localStorage.userInfo).mobile, // 登录用户手机号
          taxRegNum: that.isCheck === '企业' ? that.form.regNum : '', // 纳税人识别号
          ftList: that.$route.params.arr,
          invBankName: that.form.depositBank ? that.form.depositBank : '', // 开户行名称
          invBankAcct: that.form.accountNumber ? that.form.accountNumber : '', // 开户行账号
          Gmfdz: that.form.companyAddress ? that.form.companyAddress : '', // 公司地址
          Gmfdh: that.form.companyPhone ? that.form.companyPhone : '', // 公司联系电话
          bz: that.isCheck === '企业' ? that.form.remarks : that.form.selfRemarks
        }
        applyBilling(params).then(res => {
          that.loading = false
          if (res && res.data.success) {
            this.$message({
              message: '开票申请提交成功，请您到邮箱查看',
              type: 'success'
            })
          } else {
            this.$message.error(res.data.message ? res.data.message : '开票失败')
          }
        }).catch(() => {
          that.loading = false
          this.$message.error('请求失败')
        })
      }
    }
  }
</script>

<style scoped>
  .title-div {
    width: 88.5%;
    height: 158px;
    background: #BD1A2D;
    font-size: 38px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 158px;
    padding-left: 11.5%;
  }

  .tip-div {
    padding: 22px 20% 45px 19%;
  }

  .careful-div {
    width: 100%;
    background: #FFFAF4;
    border: 1px solid #FFC272;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #E19829;
    line-height: 24px;
    display: flex;
    padding: 16px 0;
  }

  .img-div {
    padding-left: 2%;
  }

  .form-div {
    padding: 0 38% 80px 39%;
  }

  .invoice-type-div {
    font-size: 22px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #333333;
  }

  .button-style {
    width: 43%;
    height: 40px;
    border-radius: 0px 2px 2px 0px;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    padding: 0;
    border: 1px solid #BD1A2D;
  }

  .no-btn {
    color: #BD1A2D;
  }

  .check-btn {
    background: #BD1A2D;
    color: #FFFFFF;
  }

  .no-btn:focus, .no-btn:hover {
    color: #BD1A2D;
    border-color: #BD1A2D;
    background-color: #FFF;
  }

  .check-btn:focus, .check-btn:hover {
    color: #FFFFFF;
    border-color: #BD1A2D;
    background-color: #BD1A2D;
  }

  .button-div {
    margin-top: 12px;
    margin-bottom: 60px;
  }

  .invoice-header-input {
    width: 93%;
  }

  /deep/ .el-form-item__content {
    display: flex;
    align-items: center;
  }

  .img-style {
    margin-left: 3%;
    line-height: 100%;
  }

  /deep/ .el-form-item__label {
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #333333;
  }

  .invoice-detail-div {
    margin-bottom: 18px;
  }

  .row-div {
    display: flex;
    width: 90.7%;
    height: 40px;
    background: #F6F6F6;
    border-radius: 2px;
    border: 1px solid #DCDFE6;
    align-items: center;
  }

  .left-cell {
    width: 50%;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #757575;
    padding-left: 4%;
  }

  .right-cell {
    width: 50%;
    text-align: right;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #333333;
    padding-right: 4%;
  }

  .invoice-amount-div {
    margin-top: 12px;
    margin-bottom: 22px;
  }

  /deep/ .el-collapse-item__wrap {
    border-bottom: none;
  }

  .el-collapse {
    border-top: none;
    border-bottom: none;
  }

  /deep/ .el-collapse-item__header {
    border-bottom: none;
  }

  .more-span {
    text-align: right;
    width: 90%;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    color: #BD1A2D;
  }

  /deep/ .el-collapse-item__arrow {
    font-size: 18px;
    color: #BD1A2D;
  }

  .phone-span {
    color: #C53647;
  }

  .submit-button {
    width: 93%;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    height: 40px;
    padding: 0;
  }

  .el-button--primary {
    background-color: #BD1A2D;
    border-color: #BD1A2D;
  }

  .el-button--primary:focus, .el-button--primary:hover {
    background: #BD1A2D;
    border-color: #BD1A2D;
  }

  .el-button {
    border-radius: 0px 2px 2px 0px;
    border: 1px solid #BD1A2D;
  }

  .invoice-header {
    width: 91.3%;
  }

  .tip-div-invoice {
    text-align: center;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #BD1A2D;
  }

  .cancel-button {
    width: 80px;
    height: 36px;
    background: #F0F2F5;
    border: 1px solid #D7DBE0;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #333333;
    padding: 0;
    border-radius: 0;
  }

  .confirm-button {
    width: 80px;
    height: 36px;
    background: #BD1A2D;
    border: 1px solid #BD1A2D;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    padding: 0;
    border-radius: 0;
  }

  /*.el-button:focus, .el-button:hover {
    color: #333333;
    border-color: #D7DBE0;
    background-color: #F0F2F5;
  }*/

  .el-button--primary:focus, .el-button--primary:hover {
    background: #BD1A2D;
    border-color: #BD1A2D;
    color: #FFF;
  }

  /deep/ .el-dialog--center {
    border-radius: 12px;
  }

  /deep/ .el-dialog__headerbtn:focus .el-dialog__close, /deep/ .el-dialog__headerbtn:hover .el-dialog__close {
    color: #BD1A2D;
  }
</style>
